import { classes } from '../const';

const { isOpen, isHidden } = classes;

const initFilterAccordion = $el => {
  const $btn = $el.find('.js-acc-filter-btn');
  const $body = $el.find('.js-acc-filter-body');
  const $$selectedBtns = $el.find('.js-acc-filter-selected-item');
  const $$inputs = $body.find('input[type=checkbox]');

  $body.removeClass(isHidden).hide();

  $el.addClass(isOpen);
  $body.slideDown();

  $btn.click(event => {
    event.preventDefault();
    $el.toggleClass(isOpen);

    if ($el.hasClass(isOpen)) {
      $body.slideDown();
    } else {
      $body.slideUp();
    }
  });

  const initSelectedBtn = $selectedBtn => {
    const $targetInput = $el.find(`input[type=checkbox][value="${$selectedBtn.data('value')}"]`);


    const watchInput = () => {
      setTimeout(() => {
        if (!$targetInput.prop('checked')) {
          $targetInput.off('change', watchInput);
          $selectedBtn.remove();
        }
        if (!$el.find('.js-acc-filter-selected-item').length) {
          $el.find('.js-acc-filter-selected').remove();
        }
      }, 0);
    };

    $targetInput.on('change', watchInput);

    $selectedBtn.click(event => {
      event.preventDefault();
      $targetInput.prop('checked', false);
      $targetInput.change();
    });

  };

  $$inputs.each((i, input) => {
    const $input = $(input);

    const addSelectedWrap = () => {
      $btn.after(`
      <div class="filter-accordion__selected-wrap">
      <div class="filter-accordion__selected js-acc-filter-selected"></div>
      </div>
      `);
    };



    $input.change(() => {

      let $selected = $el.find('.js-acc-filter-selected');

      if ($input.prop('checked')) {
        const selectTitle = $input.parent().find('.checkbox__title').html();

        if (!$selected.length) {
          addSelectedWrap();
          $selected = $el.find('.js-acc-filter-selected');
        }

        const $selectedBtn = $(`
          <button type="button" class="filter-accordion__selected-item js-acc-filter-selected-item" data-value="${$input.val()}">
            <span class="button-icon">I</span>
            <span>${selectTitle}</span>
          </button>
        `);


        $selected.append($selectedBtn);
        initSelectedBtn($selectedBtn);

      }
    });

  });

  $$selectedBtns.each((j, btn) => {
    initSelectedBtn($(btn));
  });
};



const filterAccordions = () => {
  const $$filterAccordions = $('.js-acc-filter');

  $$filterAccordions.each((i, el) => {
    initFilterAccordion($(el));
  });
};

export default filterAccordions;
